
import axios from 'axios';
import React, { Component}  from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { pluralize } from 'common/Pluralize';
import { Drawer } from 'ui/Drawer';
import { YellowButton } from 'ui/Button';
import { OrderPointServiceForm } from './OrderPointServiceForm';

const StyledAvailableServiceList = styled.div`
  button {
    margin: 0 5px 5px 0;
  }
  button.active {
    color: #FFFFFF;
    background: #000000;
  }
`;


export class OrderPointServicesForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false,
      allServices: [],
      tariffServices: [],
      showAllServices: false,
      showAllTariffServices: false,
      servicesWithCost: []
    };
  }

  toggleDrawer = () => {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
      showAllServices: false,
      showAllTariffServices: false
    }, () => {
      if (this.state.isDrawerOpen) {
        this.loadAllServices();
        this.loadTariffServices();
        this.loadServicesWithCost();
        this.setState({
          showAllServices: false
        })
      }
    });
  };

  addService = (service) => {
    const { context, pointIndex, orderPoint } = this.props;
    const fieldPath = `points.${pointIndex}.services`;
    if (!this.isServiceExists(service.id)) {

      let quantity = 1;
      if (service.tariffication === 'BY_MILEAGE' && orderPoint.point.distance) {
        quantity = orderPoint.point.distance;
      }

      context.pushArrayValue(fieldPath, {
        service: service,
        quantity: quantity,
        cost: this.findTariffCost(service.id),
      })
    }
  };

  findTariffCost = (serviceId) => {
    const serviceWithCost = _.find(this.state.servicesWithCost, {id: serviceId});
    return serviceWithCost ? serviceWithCost.cost : 0.00;
  };

  isServiceExists = (serviceId) => {
    const { orderPoint } = this.props;
    const results = _.filter(orderPoint.services, function(o) {
      return o.service.id === serviceId && !o.is_delete;
    });
    return results.length > 0;
  };

  loadAllServices = () => {
    const { orderPoint } = this.props;
    const point = orderPoint.point;
    axios.get(`${point.meta.url}services/`).then(res => {
      this.setState({
        allServices: _.filter(res.data.services, { is_active: true})
      })
    });
  };

  loadTariffServices = () => {
    const { context } = this.props;
    if (context.item.tariff) {
      const tariffId = context.item.tariff.id ? context.item.tariff.id : context.item.tariff;
      axios.get(`tariff/${tariffId}/services/?is_active`).then(res => {
        this.setState({
          tariffServices: res.data
        })
      });
    }
  }

  loadServicesWithCost = () => {
    const { context, orderPoint } = this.props;
    if (context.item.tariff) {
      const tariffId = context.item.tariff.id ? context.item.tariff.id : context.item.tariff;
      axios.get(`tariff/${tariffId}/services_by_point/?point_id=${orderPoint.point.id}&is_active`).then(res => {
        this.setState({
          servicesWithCost: res.data
        })
      });
    }
    else {
      this.setState({
        servicesWithCost: []
      })
    }
  };

  calculateAmount = (pointServices) => {
    let amount = 0.0;
    pointServices.forEach(service => {
      amount += service.quantity * service.cost
    });

    return amount.toFixed(2);
  };

  getPointServices = (services) => {
    return _.filter(services, function (obj) {
      return !obj.is_delete;
    })
  };

  filterServicesByContainerType = () => {
    const { context } = this.props;
    const { allServices, showAllServices } = this.state;
    const order = context.item;
    let filteredServices = allServices;
    if (order.container_type && showAllServices === false) {
      filteredServices = _.filter(allServices,  (service) => {
        return service.container_type === null ||
          service.container_type === order.container_type.id ||
          this.isServiceExists(service.id);
      });
    }

    return {
      filteredServices: filteredServices,
      hasHiddenServices: filteredServices.length !== allServices.length,
      hiddenServicesCount: allServices.length - filteredServices.length
    }
  };

  filterTariffServices = () => {
    const { context } = this.props;
    const { allServices, tariffServices, showAllTariffServices } = this.state;

    const order = context.item;
    const pointServicesIds = allServices.map(service => service.id);
    const allTariffServices = _.filter(tariffServices, function (service) {
      return !pointServicesIds.includes(service.id);
    });

    let filteredTariffServices = allTariffServices;
    if (order.container_type && showAllTariffServices === false) {
      filteredTariffServices = _.filter(allTariffServices,  (service) => {
        return service.container_type === null ||
          service.container_type === order.container_type.id ||
          this.isServiceExists(service.id);
      });
    }

    return {
      filteredTariffServices: filteredTariffServices,
      hasHiddenTariffServices: allTariffServices.length !== filteredTariffServices.length,
      hiddenTariffServicesCount: allTariffServices.length - filteredTariffServices.length
    }
  }

  render() {
    const { context, pointIndex, orderPoint } = this.props;
    const point = orderPoint.point;
    const activePointServices = this.getPointServices(orderPoint.services);
    let number = 1;

    const {
      filteredServices,
      hasHiddenServices,
      hiddenServicesCount
    } = this.filterServicesByContainerType();
    const {
      filteredTariffServices,
      hasHiddenTariffServices,
      hiddenTariffServicesCount
    } = this.filterTariffServices();

    return (
      <React.Fragment>

        <Button
          onClick={() => this.toggleDrawer()}
          variant="outlined"
          size={'small'}
          fullWidth={true}
        >
          {activePointServices.length === 0 && (
            <React.Fragment>+ Услуги</React.Fragment>
          )}
          {activePointServices.length > 0 && (
            <React.Fragment>
              {activePointServices.length} {pluralize(activePointServices.length, ['услуга', 'услуги', 'услуг'])}
              , {this.calculateAmount(activePointServices)}₽
            </React.Fragment>
          )}
        </Button>

        <Drawer
          open={this.state.isDrawerOpen}
          onClose={() => this.toggleDrawer()}
          width={'600px'}
        >
          <h2>Услуги на точке {point.name}</h2>

          <h3>Общие услуги тарифа</h3>
          <StyledAvailableServiceList>
            {filteredTariffServices.map(service =>
              <Button
                key={service.id}
                onClick={() => this.addService(service)}
                variant={'outlined'}
                className={this.isServiceExists(service.id) ? 'active' : ''}
              >
                {service.label}
              </Button>
            )}
            {hasHiddenTariffServices && (
              <Button
                onClick={() => this.setState({showAllTariffServices: true})}
              >
                Показать скрытые - {hiddenTariffServicesCount}
              </Button>
            )}
          </StyledAvailableServiceList>

          <h3>Услуги на точке</h3>
          <StyledAvailableServiceList>
            {filteredServices.map(service =>
              <Button
                key={service.id}
                onClick={() => this.addService(service)}
                variant={'outlined'}
                className={this.isServiceExists(service.id) ? 'active' : ''}
              >
                {service.label}
              </Button>
            )}
            {hasHiddenServices && (
              <Button
                onClick={() => this.setState({showAllServices: true})}
              >
                Показать скрытые - {hiddenServicesCount}
              </Button>
            )}
          </StyledAvailableServiceList>

          {activePointServices.length > 0 && (
            <h3>Задайте стоимость</h3>
          )}

          {orderPoint.services.map((pointService, index) =>
            <React.Fragment key={index}>
              {!pointService.is_delete && (
                <OrderPointServiceForm
                  key={index}
                  number={number++}
                  pointService={pointService}
                  pointIndex={pointIndex}
                  serviceIndex={index}
                  context={context}
                />
              )}
            </React.Fragment>
          )}

          <div className={'mt-20'}>
            <YellowButton
              size={'large'}
              onClick={(e) => this.toggleDrawer()}
            >
              Добавить услуги
            </YellowButton>
          </div>
        </Drawer>
      </React.Fragment>
    )
  }
}
